import { api } from "../../../utils/api";
import { TOKEN } from "../../../utils/localStorage";
import { getCookie } from "cookies-next";

// Login API

export const userLoginApi = async (data) => {
  return await api.post(`/auth/login`, data, {
    headers: { "x-access-token": getCookie(TOKEN) },
  });
};

export const userLoginWithUserNameApi = async (data) => {
  return await api.post(`/auth/login-username`, data, {
    headers: { "x-access-token": getCookie(TOKEN) },
  });
};

// Logout API

export const userLogOutApi = async (data) => {
  return await api.post(`/auth/logout`, data, {
    headers: { "x-access-token": getCookie(TOKEN) },
  });
};

//  Forgot Password API

export const userForgotPasswordApi = async (data) => {
  return await api.post(`/user/change-password-request`, data, {
    headers: { "x-access-token": getCookie(TOKEN) },
  });
};

// Notification API

export const getNotificationListApi = async () => {
  return await api.get(`/defect-report-notification/list`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateNotificationListApi = async (data) => {
  return await api.post(
    `/defect-report-notification/all-unread-notification`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};
